import { createAsyncThunk } from '@reduxjs/toolkit';
import { FaqChannelsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { IGetFaqChannelsResponse } from '@/models/faqChannel.model';
import { SLICE_NAME } from './models';

export const getFaqChannels = createAsyncThunk<IGetFaqChannelsResponse, void, { serializedErrorType: IApiError }>(
  `${SLICE_NAME}/getFaqChannels`,
  async () => {
    const response = await FaqChannelsAPI.getFaqChannels();
    return response.data;
  },
  { serializeError: formatApiError },
);
